import { prepareMessages } from '@ci/message/node';

export const m = prepareMessages('sessionTimeout', [
	['loggedOut', 'You have been logged out due to inactivity'],
]);
